<template>
  <div>
    <template v-if="ooptId">
      <ul class="list-column">
        <li>
          <router-link :to="{ name: 'department-bso-invoice', params: { id: ooptId } }">{{ $t('Учет накладных') }}</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'department-bso-accounting', params: { id: ooptId } }">{{ $t('Учет БСО') }}</router-link>
        </li>
      </ul>
    </template>
    <template v-else>
      <ul class="list-column">
        <li>
          <router-link :to="{ name: 'bso-list' }">{{ $t('Список БСО') }}</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'bso-invoice' }">{{ $t('Учет накладных') }}</router-link>
        </li>
        <li>
          <router-link :to="{ name: 'bso-accounting' }">{{ $t('Учет БСО') }}</router-link>
        </li>
      </ul>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    ooptId: Number
  }
}
</script>

<style scoped>

</style>
